var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 7.07259L12.0534 3.09455C11.9427 3.03544 11.8099 3.03627 11.7 3.09662L4.43998 7.07467C4.32092 7.14 4.24707 7.26486 4.24707 7.40071V12.5971C4.25143 16.8686 6.78253 20.733 10.6968 22.4443L11.7045 22.8833C11.7987 22.9244 11.9059 22.9246 12.0003 22.8838L13.1358 22.3934C17.1227 20.7193 19.7164 16.8176 19.7169 12.494V7.40071C19.7169 7.26341 19.6411 7.1371 19.52 7.07259ZM18.9734 12.494C18.9726 16.5195 16.557 20.1518 12.8448 21.7096L12.8423 21.7109L11.8535 22.1377L10.9943 21.7629C7.35069 20.1701 4.99445 16.5732 4.99031 12.5971V7.62077L11.881 3.84474L18.9734 7.62346V12.494Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13797 12.3561C9.00459 12.1999 8.76998 12.1814 8.61378 12.3148C8.45759 12.448 8.43912 12.6828 8.5725 12.8388L10.5361 15.1382C10.6672 15.2917 10.8968 15.3126 11.0532 15.1853L15.6263 11.4647C15.7856 11.3353 15.8096 11.1011 15.68 10.9418C15.5506 10.7827 15.3164 10.7584 15.1571 10.8881L10.8657 14.3792L9.13797 12.3561Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/TC.6ca09bde159460eb6e35e102e98fc6a8.svg";
export { ForwardRef as ReactComponent };